<template>
    <div id="chat-page">
        <AppBreadCrumb
            :paths="[{ title: $t('message.CHAT'), path: 'chat' }]"
            :select="!!activeConversation || !['siteVisitors', 4].includes(tab)"
            :show-trial-remain-day="true"
            @to-chat-main="toMainMenu"
            :key="Math.random()"
        >
            <select
                v-if="tab === 'conversationHistory' && !activeConversation"
                id="time-select"
                v-model="timeSelect"
                @change="saveFilter"
            >
                <option value="today">{{ $t("time.today") }}</option>
                <option value="yesterday">{{ $t("time.yesterday") }}</option>
                <option value="current-week">
                    {{ $t("time.currentWeek") }}
                </option>
                <option value="last-week">{{ $t("time.lastWeek") }}</option>
                <option value="current-month">
                    {{ $t("time.currentMonth") }}
                </option>
                <option value="last-month">{{ $t("time.lastMonth") }}</option>
                <option value="last-30">{{ $t("time.last30Day") }}</option>
                <option v-for="(m, i) in getLast11Months()" :key="i" :value="m.date">
                    {{ m.name }}
                </option>
                <!--                Tüm Zamanlar Kaldırıldı-->
                <!--                <option value="all-time">{{ $t("time.allTime") }}</option>-->
                <option value="custom">Custom</option>
            </select>
            <a-button
                v-if="tab === 'conversationHistory' && !activeConversation"
                class="actionButton d-flex align-items-center classic-button ant-btn-reset"
                size="small"
                @click="resetFilters"
                v-tippy="{ placement: 'bottom' }"
                :content="$t('message.clearSelectedFiltersTooltip')"
            >
                <span
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t('message.clearSelectedFiltersTooltip')"
                    style="display: block; font-size: 12px"
                >
                    <span class="md-icon">delete_forever</span>
                </span>
            </a-button>

            <div v-if="tab === 'representative' && !activeConversation" class="chatListSettingContainer">
                <div
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('message.showOnlineAgents')"
                    class="custom-checkbox2"
                >
                    <a-switch v-model="showOnlineAgents" size="small">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                    </a-switch>
                    <span>{{ $t("message.showOnlineAgents") }}</span>
                </div>
            </div>
        </AppBreadCrumb>
        <div class="route-page-content breadcrumb-content">
            <ChatSidebar v-model="tab" />
            <div class="page-content-wrapper">
                <b-alert :show="socketConnecting && user != null" class="rounded-0" variant="info">
                    {{ $t("message.socketConnecting") }}
                </b-alert>

                <UpgradeNeededPageOverlay
                    v-if="upgrade.enabled && upgrade.type === 'chat-overlay'"
                    :plan="upgrade.plan"
                    :feature="upgrade.feature"
                    :name="upgrade.name"
                />
                <ChatWindowManager v-else-if="isLiveSupportMenuActivated()" />
                <TeamChat v-else-if="tab === 'teamChat'" :visible="selectedInbox === 'team'" />
                <VisitorList v-else-if="tab === 'siteVisitors'" />
                <VisitorHistory
                    v-else-if="tab === 'conversationHistory'"
                    :time-select="timeSelect"
                    @customTime="timeChanged"
                    @timeSelectChanged="(val) => (timeSelect = val)"
                    ref="visitorHistory"
                />
                <AgentList
                    v-else-if="tab === 'representative'"
                    :assign="false"
                    :info-button-visible="true"
                    :reportButton="true"
                    :showOnlineAgents="showOnlineAgents"
                />
                <WhatsappContactListSwitcher v-else-if="tab === 'whatsappContacts'" />
                <InstagramContactListSwitcher v-else-if="tab === 'instagramContacts'" />
                <LinkedinContactListSwitcher v-else-if="tab === 'linkedinContacts'" />
                <TelegramContactListSwitcher v-else-if="tab === 'telegramContacts'" />
                <MessengerContactListSwitcher v-else-if="tab === 'messengerContacts'" />
                <iframe
                    class="website-tracking-iframe"
                    :src="websiteTrackingUrl"
                    v-if="tab === 'websiteAnalytics' && websiteTrackingUrl"
                />
                <AutomationList type="event" module="chat" v-if="tab === 'automations'" />
                <LeadList
                    v-if="tab === 'metaLeads' && metaLeadChannel"
                    :channel="metaLeadChannel"
                    :channel-id="metaLeadChannel._id"
                    :form-mode="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import VisitorList from "../../../components/VisitorList";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faHistory, faUsers } from "@fortawesome/free-solid-svg-icons";
import VisitorHistory from "../../../components/VisitorHistory";
import PrivateMessage from "../../../components/PrivateMessage";
import AgentList from "../../../components/AgentList";
import ChatStats from "../../../components/ChatStats";
import KeyboardShortcuts from "../../../components/KeyboardShortcuts";
import ConversationColorHelp from "../../../components/ConversationColorHelp";
import { log2 } from "../../../utils/log2";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import SupportAgent from "../../../components/svg/SupportAgent";
import { sendSocketMessage } from "../../../utils/socketStream";
import BotChatList from "../../../components/BotChatList";
import VideoCallScreen from "../../../components/VideoCallScreen";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { filter, map } from "rxjs/operators";
import _ from "lodash";
import WhatsappContactList from "../../../components/WhatsappContactList";
import WhatsappContactListV2 from "../../../components/WhatsappContactListV2";
import TeamChat from "./../TeamChat/TeamChat";
import CONFIG from "../../../config/config";
import { isMac } from "../../../utils/utils";
import Modal2 from "../../../components/common/Modal2";
import TimeUtils from "../../../utils/TimeUtils";
import CalendarEvents from "../Calendar/Component/calendar-events/CalendarEvents.vue";
import WhatsappContactListSwitcher from "../IntegrationChannelsItem/WhatsappContactListSwitcher.vue";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import InstagramContactListSwitcher from "../Integrations/instagram/InstagramContactListSwitcher.vue";
import MessengerContactListSwitcher from "../Integrations/messenger/MessengerContactListSwitcher.vue";
import ChatWindowManager from "../../../components/popup-chat/chat-window/ChatWindowManager.vue";

import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import ChatSidebar from "./components/ChatSidebar.vue";
import UpgradeNeededPageOverlay from "../../../components/billing/UpgradeNeededPageOverlay.vue";
import AutomationList from "../Automation/pages/automations/AutomationList.vue";
import LeadList from "../Integrations/meta-leads/LeadList.vue";
import LinkedinContactListSwitcher from "../Integrations/linkedin/LinkedinContactListSwitcher.vue";
import TelegramContactListSwitcher from "../Integrations/telegram/TelegramContactListSwitcher.vue";

library.add(faEye, faUsers, faHistory);

const log = log2("Chat");

export default {
    name: "Chat",
    components: {
        TelegramContactListSwitcher,
        UpgradeNeededPageOverlay,
        ChatWindowManager,
        ChatSidebar,
        MessengerContactListSwitcher,
        WhatsappContactListSwitcher,
        InstagramContactListSwitcher,
        LinkedinContactListSwitcher,
        CalendarEvents,
        SidebarChild,
        TeamChat,
        WhatsappContactList,
        WhatsappContactListV2,
        AppBreadCrumb,
        ChatStats,
        AgentList,
        VisitorList,
        PrivateMessage,
        VisitorHistory,
        KeyboardShortcuts,
        ConversationColorHelp,
        SupportAgent,
        BotChatList,
        VideoCallScreen,
        Modal2,
        AutomationList,
        LeadList,
    },
    data() {
        return {
            isMac,
            showOnlineAgents: false,
            tab: this.$route.query.tab ? this.$route.query.tab : "inbox",
            users: [],
            cancelTokens: [],
            timeSelect: localStorage.getItem("timeSelect") || "today",
            carouselRef: null,
            chatCountMod: 0,
            handleShortcuts: null,
            inboxShortcuts: null,
            position: "right",
            selectedInbox: "inbox",
            teamChatEnabled: CONFIG.TEAM_CHAT.enabled,
            activityEnabled: CONFIG.ACTIVITY.enabled,
            disableKeyboardListener: false,
            assignAgentModal: false,
            forwardAgentModal: false,
            isDialog: false,
        };
    },
    computed: {
        ...mapState({
            websiteTrackingUrl: (state) => state.setting.settings?.websiteTrackingUrl,
            upgrade: (state) => state.app.upgrade,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
            observing: (state) => state.chat.observing,
            previousConversation: (state) => state.chat.previousConversation,
            privateMessageConversation: (state) => state.chat.privateMessageConversation,
            site: (state) => state.site.site,
            socketConnected: (state) => state.socketStatus.socket_connected,
            isAdmin: (state) => state.auth.adminUser != null,
            visitorViewPermissionExits: (state) => {
                const isRoot = !!state.auth.adminUser || _.get(state.auth.user, "role.isRoot");
                return (
                    isRoot ||
                    !!(_.get(state.auth.user, "role.permissions") || []).find((x) => x.name === "visitor.view")
                );
            },
            ticketViewPermissionExists: (state) => {
                const isRoot = _.get(state.auth.user, "role.isRoot");
                return (
                    isRoot ||
                    !!(_.get(state.auth.user, "role.permissions") || []).find(
                        (x) => x.name === "offlineSupportRequest.get"
                    )
                );
            },
            tabVisible: (state) => state.app.tabVisible,
            disconnected: (state) => {
                return state.socketStatus.connection_count > 0 && !state.socketStatus.socket_connected;
            },
            socketConnecting: (state) => {
                return state.socketStatus.connection_count === 0 && !state.socketStatus.socket_connected;
            },
            liveVisitors: (state) => state.visitor.liveVisitors,
            liveVisitorCount: (state) => state.visitor.liveVisitorCount,
            privateChatIsOpen: (state) => state.app.privateChatIsOpen,
            offlineMode: (state) => state.setting.offlineMode,
            chatBot: (state) => state.setting.settings.chatbot,
            chatBarCurrentPage: (state) => state.app.chatBarCurrentPage,
            chatBarPageSize: (state) => state.app.chatBarPageSize,
            isDarkMode: (state) => state.user.darkMode,
            stats: (state) => state.chat.stats,
            isChatHistoryOpen: (state) => state.chat.isChatHistoryOpen,
            videoCallMode: (state) => state.webrtc.videoCallMode,
            chatTotal: (state) => state.chat.stats.total,
            unreadMessages: (state) => state.team.unreadMessages.filter((chat) => chat.unreadCount > 0).length,
            previousContactId: (state) => state.chat.previousContactId,
            watchingContactIds: (state) => state.chat.watchingContactIds,
            contactLists: (state) => state.chat.contactLists,
            metaLeadChannel: (state) => state.channel.channels.find((x) => x.type === "meta-leads"),
        }),
        ...mapGetters({
            activeConversations: "chat/getActiveConversations",
            myActiveConversations: "chat/getMyActiveConversations",
            waitingConversations: "chat/getWaitingConversations",
            waitingOfflineSupportRequestCount: "offlineSupportRequest/waitingOfflineSupportRequestCount",
            getPopoversStatus: "app/getPopoversStatus",
            whatsappEnabled: "setting/whatsappEnabled",
            unreadChatCount: "team/unreadChatCount",
            whatsappServiceIsHealthy: "whatsapp/isHealthy",
            checkPermission: "auth/checkPermission",
        }),
        isCalendarReadable() {
            return this.checkPermission(PERMISSION_TYPES["calendar.read"].tr.name);
        },
    },
    methods: {
        ...mapActions({
            changeTeamChatVisible: "team/changeTeamChatVisible",
            endConversation: "chat/endConversation",
            leaveConversation: "chat/leaveConversation",
            joinContactConversation: "chat/joinContactConversation",
            viewConversation: "chat/viewConversation",
            hideConversation: "chat/hideConversation",
            getSettings: "setting/getSettings",
            getUsers: "user/getUsers",
            getOfflineSupportRequests: "offlineSupportRequest/getOfflineSupportRequests",
            setChatBarCurrentPageChange: "app/setChatBarCurrentPageChange",
        }),
        isLiveSupportMenuActivated() {
            return this.tab === "inbox";
        },
        getMenus() {
            return;
        },

        saveFilter() {
            localStorage.setItem("timeSelect", this.timeSelect);
        },
        loadFilter() {
            const savedFilter = localStorage.getItem("timeSelect");
            if (savedFilter) {
                this.timeSelect = savedFilter;
            }
        },
        teamInbox() {
            this.selectedInbox = "team";
            this.tab = "teamChat";
            this.disableKeyboardListener = true;
        },
        supportInbox() {
            this.selectedInbox = "inbox";
            this.tab = "inbox";
            this.disableKeyboardListener = false;
        },
        toMainMenu() {
            this.tab = "inbox";
        },
        timeChanged() {
            this.timeSelect = "custom";
            this.saveFilter();
        },
        getRef(ref) {
            this.carouselRef = ref;
        },
        getLast11Months() {
            return TimeUtils.getLast11Months();
        },
        resetFilters() {
            if (this.$refs.visitorHistory) {
                const resetValues = {
                    startDate: null,
                    endDate: null,
                    query: null,
                    point: null,
                    selectedUser: null,
                    selectedCustomerDomains: null,
                };
                this.$refs.visitorHistory.handleResetFilters(resetValues);
            }
        },
    },
    mounted() {
        this.loadFilter();
        if (
            !this.$route.query.tab ||
            (this.$route.query.tab === "inbox" && !this.$route.query.inbox) ||
            (this.$route.query.tab === "inbox" && !this.$route.query.view)
        ) {
            const currentQuery = Object.assign({}, this.$route.query);
            console.log("currentQuery", {
                currentQuery,
                overrid: Object.assign({}, currentQuery, {
                    tab: currentQuery.tab || "inbox",
                    inbox: currentQuery.inbox || "myInbox",
                    view: currentQuery.view || "chat",
                }),
            });
            this.$router.replace({
                query: Object.assign({}, currentQuery, {
                    tab: currentQuery.tab || "inbox",
                    inbox: currentQuery.inbox || "myInbox",
                    view: currentQuery.view || "chat",
                }),
            });
        }
        this.selectedInbox = this.$route.query.tab === "teamChat" ? "team" : "inbox";
        this.tab = this.isAdmin ? "conversationHistory" : this.tab;
        this.getUsers({
            page: 1,
            perPage: 1000,
        });
        this.getSettings().then();
        if (this.ticketViewPermissionExists) this.getOfflineSupportRequests({ perPage: 100, pageCount: 1 });

        const compareOSKey = (e, key) => {
            const platform = window.navigator.platform || window.navigator.oscpu;

            if (platform.toLowerCase().indexOf("mac") !== -1) {
                return e.altKey && e.key === key;
            } else {
                return e.ctrlKey && e.key === key;
            }
        };
        const handleShortcuts = (e) => {
            const isInput = _.get(e, "target.nodeName") === "INPUT";
            log("handleShortcuts", e, { isInput });

            const classList = _.get(e, "target.classList");
            const disableShortcut = classList ? classList.contains("disableShortcut") : false;
            log.debug("handleShortcuts", { e, classList, disableShortcut });
            if (isInput || disableShortcut || this.disableKeyboardListener) return;
            //activated only gasline
            const FShortcutsEnabled = ["65dde31f325ce2d725be1d5a"].includes(this.site._id);
            if ("F1" === e.key && FShortcutsEnabled) {
                SYSTEM_PUBSUB.publish("focus_content");
            } else if ("F2" === e.key) {
                e.preventDefault();
                sendSocketMessage("user join-to-most-waited", {
                    siteId: this.site._id,
                    userId: this.user._id,
                });
            } else if ("F3" === e.key && FShortcutsEnabled) {
                e.preventDefault();
                let unreadMessageChats = this.contactLists.filter((x) => x.unreadedCount > 0);
                if (unreadMessageChats.length > 0) {
                    const topContact = unreadMessageChats.sort(
                        (a, b) => this.$moment(a.lastInteractionDate) - this.$moment(b.lastInteractionDate)
                    )[0];
                    if (topContact) {
                        this.joinContactConversation(topContact);
                    }
                }
            } else if ("F4" === e.key && FShortcutsEnabled) {
                e.preventDefault();
                const contact = this.contactLists.find((x) => x._id === this.previousContactId);
                if (contact) this.joinContactConversation(contact);
            } else if (
                _.takeRight(_.range(10), 9)
                    .map((x) => x + "")
                    .includes(e.key) &&
                !e.metaKey &&
                !e.ctrlKey &&
                !this.privateChatIsOpen &&
                !this.getPopoversStatus &&
                false
            ) {
                const editorIsFocused = document.getElementsByClassName("ck-focused")[0];
                if (
                    this.myActiveConversations.length &&
                    this.myActiveConversations.length >= Number(e.key) &&
                    !editorIsFocused
                ) {
                    e.preventDefault();
                    let _conversation =
                        this.myActiveConversations[
                            Number(e.key) - 1 + Math.max(this.chatBarCurrentPage - 1, 0) * this.chatBarPageSize
                        ];
                    if (_conversation) {
                        if (!this.activeConversation || _conversation._id !== this.activeConversation._id) {
                            this.joinConversation({
                                conversation: _conversation,
                                observe: this.observing.includes(_conversation._id),
                                sendToSocket: false,
                                minimized: false,
                            });
                            const editorEl = document.getElementsByClassName("ck-editor__editable")[0];

                            setTimeout(
                                function () {
                                    if (this.activeConversation && editorEl) {
                                        editorEl.focus();
                                    }
                                }.bind(this),
                                10
                            );
                        } else {
                            this.hideConversation();
                        }
                    }
                }
            } else {
                if (this.activeConversation && this.myActiveConversations.length && false) {
                    const currentConversationIndex = this.myActiveConversations.findIndex(
                        (c) => c._id === this.activeConversation._id
                    );

                    if (compareOSKey(e, "ArrowRight")) {
                        if (
                            "undefined" !== typeof currentConversationIndex &&
                            "undefined" !== typeof this.myActiveConversations[currentConversationIndex + 1]
                        ) {
                            log("opt+right", {
                                myActiveConversations: this.myActiveConversations,
                                currentConversationIndex,
                            });
                            this.viewConversation({
                                id: this.myActiveConversations[currentConversationIndex + 1]._id,
                            });

                            // Burası chatbarda 1.sayfanın 9.chatinden 2.sayfanın 1.chatine geçmek için yapılmıştır
                            // Chatbar arası opt+right kullanıldığında otomatik chatbarda sayfa geçişi yapıyor.
                            this.chatCountMod = (currentConversationIndex + 1) % 9;
                            if (this.chatCountMod === 0) {
                                /*this.carouselRef.next();*/
                                this.setChatBarCurrentPageChange(this.chatBarCurrentPage + 1);
                            }
                        }
                    } else if (compareOSKey(e, "ArrowLeft") && currentConversationIndex > 0) {
                        log("opt+left", {
                            myActiveConversations: this.myActiveConversations,
                            currentConversationIndex,
                        });
                        this.viewConversation({
                            id: this.myActiveConversations[currentConversationIndex - 1]._id,
                        });
                        // Burası chatbarda 2.sayfanın 1.chatinden 1.sayfanın 9.chatine geçmek için yapılmıştır
                        // Chatbar arası opt+left kullanıldığında otomatik chatbarda sayfa geçişi yapıyor.
                        this.chatCountMod = currentConversationIndex % 9;
                        if (this.chatCountMod === 0 && currentConversationIndex > 1) {
                            /*this.carouselRef.prev();*/
                            this.setChatBarCurrentPageChange(this.chatBarCurrentPage - 1);
                        }
                    } else if (compareOSKey(e, "ArrowDown")) {
                        this.hideConversation(this.activeConversation._id);
                    } else if (compareOSKey(e, "ArrowUp")) {
                        if (this.activeConversation.status !== "destroyed") {
                            if (this.observing.includes(this.activeConversation._id)) {
                                this.leaveConversation(this.activeConversation._id);
                            } else {
                                if (!this.isDialog) {
                                    this.isDialog = true;
                                    setTimeout(() => {
                                        const el = document.querySelector(".dg-btn.dg-btn--ok.dg-pull-right");
                                        el?.focus();
                                    }, 300);
                                    this.$dialog
                                        .confirm(this.$t("message.wishToEndThisChat"), {
                                            okText: this.$t("message.continue"),
                                            cancelText: this.$t("message.cancel"),
                                        })
                                        .then(() => {
                                            this.endConversation(this.activeConversation._id);
                                            this.isDialog = false;
                                        })
                                        .catch(() => {
                                            this.isDialog = false;
                                        });
                                }
                            }
                        }
                    }
                    if (e.key === "Enter" || e.code === "Enter") {
                        SYSTEM_PUBSUB.publish("chat.enterPress", {});
                    }
                }
            }
        };

        this.handleShortcuts = handleShortcuts;
        window.addEventListener("keydown", handleShortcuts);
        this.cancelTokens.push(() => {
            window.removeEventListener("keydown", handleShortcuts);
        });

        const sub1 = SYSTEM_PUBSUB.stream
            .pipe(
                filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT),
                map((x) => x.payload.conversationId)
            )
            .subscribe(() => {
                this.tab = "inbox";
            });

        const sub2 = SYSTEM_PUBSUB.stream
            .pipe(filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_TEAM_CHAT))
            .subscribe(() => {
                this.tab = "teamChat";
                this.selectedInbox = "team";
            });
        this.cancelTokens.push(() => {
            sub1.unsubscribe();
            sub2.unsubscribe();
        });

        const inboxShortcuts = (e) => {
            log("inboxShortcuts", e);
            if ("m" === e.key && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.tab = "teamChat";
                this.selectedInbox = "team";
            }
            if ("j" === e.key && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.tab = "inbox";
                this.selectedInbox = "inbox";
            }
        };

        this.inboxShortcuts = inboxShortcuts;
        window.addEventListener("keydown", inboxShortcuts);
        this.cancelTokens.push(() => {
            window.removeEventListener("keydown", inboxShortcuts);
        });
    },
    beforeRouteUpdate(to, from, next) {
        const newQueryParam = to.query.tab;

        if (newQueryParam == "teamChat") {
            this.teamChatEnabled = true;
            this.teamInbox();
        }

        next();
    },
    watch: {
        selectedInbox(newValue) {
            if (newValue === "team") {
                this.changeTeamChatVisible(true);
            } else {
                this.changeTeamChatVisible(false);
            }
        },
        tab(newValue, oldValue) {
            if (newValue === 0) this.supportInbox();

            if (this.tab === "activities") {
                this.$router.push({ path: "/activities" });
            }
        },
        activeConversation(newVal) {
            log("activeConversation changed", newVal);
        },
        "$route.query": {
            immediate: true,
            handler(newVal) {
                if (newVal.tab) {
                    this.tab = newVal.tab;
                }
            },
        },
    },
    beforeDestroy() {
        this.cancelTokens.forEach((cancel) => cancel());
        window.removeEventListener("keydown", this.handleShortcuts);
    },
};
</script>

<style lang="scss" scoped>
.website-tracking-iframe {
    width: 100vw;
    height: 100%;
    border: none;
}

#chat-page {
    .chat-page-content {
        display: flex;
        width: 100%;
        height: calc(100% - 45px);
    }
}
</style>
<style scoped>
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-thead > tr > th,
.ant-table-small
    > .ant-table-content
    > .ant-table-fixed-left
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-thead
    > tr
    > th,
.ant-table-small
    > .ant-table-content
    > .ant-table-fixed-right
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-thead
    > tr
    > th,
.ant-table-small > .ant-table-content > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-left > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small > .ant-table-content > .ant-table-fixed-right > .ant-table-header > table > .ant-table-tbody > tr > td,
.ant-table-small
    > .ant-table-content
    > .ant-table-fixed-left
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-tbody
    > tr
    > td,
.ant-table-small
    > .ant-table-content
    > .ant-table-fixed-right
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-tbody
    > tr
    > td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 60px;
}

#team-chat-text {
    display: flex;
    gap: 3px;
}
</style>

<style lang="scss">
.right-floated-nav-item {
    position: absolute;
    right: 0;
}

.selected-link {
    color: #03a9f4;
    border: none;
    border-radius: initial;
    border-bottom: 2px solid #03a9f4;
    margin-right: 4px;
}

.menu-button {
    margin-right: 4px;
    border: none;
}

.ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
    padding: 0 !important;
}

.tt-item {
    display: block;
    margin-left: 1rem;
}

.new-theme {
    #chat-page {
        $sidebarWitdh: 75px;

        //width: calc(100vw - $sidebarWitdh);
        #chat {
            width: calc(100vw - 75px) !important;
        }

        .page-change {
            display: flex;
            border-radius: 5px;
            background-color: #d3d3d3;
            margin: 10px 0 0 30px;
            width: fit-content;

            .inbox-type {
                border-radius: 5px;
                padding: 5px;
                cursor: pointer;
                display: flex;
                gap: 5px;
                align-items: center;

                .unread-badge {
                    background-color: #ec4a1d;
                    color: white;
                    font-size: 10px;
                    padding: 3px 5px;
                    border-radius: 5px;
                    border: 1px solid white;
                    height: 18px;
                    text-align: center;
                    line-height: 10px;
                }

                .keyboard-shortcut {
                    display: flex;
                    border: 1px solid #ec4a1d;
                    color: #ec4a1d;

                    font-size: 12px;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    min-width: 16px;
                    height: 18px;
                    border-radius: 4px;
                    padding: 0 4px;
                    white-space: nowrap;
                    margin-right: 5px;
                }

                &.selected-type {
                    .keyboard-shortcut {
                        display: none;
                        border: 1px solid white;
                        color: white;
                    }
                }
            }

            .selected-type {
                background-color: #ec4a1d;
                color: white;
                font-weight: 600;
            }
        }

        .custom-table {
            background-color: #ffffff;
            border-radius: 6px;
            padding: 10px 20px;
            overflow-y: auto;
        }

        #time-select {
            border: none;
            background-color: #f3f6f9;
            padding: 3px 10px;
            border-radius: 6px;
            font-size: 12px;
            font-family: Poppins;
            font-weight: bolder;
            color: #3699ff;
        }

        .chatListSettingContainer {
            display: flex;
            justify-content: left;
            width: 15%;
            position: absolute;
            margin-top: 2px;
            z-index: 50;

            div {
                margin-right: 10px;
            }
        }

        .custom-checkbox2 {
            background-color: #f3f6f9;
            border-radius: 6px;
            padding: 4px 6px;
            max-width: 120px;
            width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            font-family: Poppins;
            font-weight: 400;
            font-size: 12px;
            color: #1e1e2d;
        }

        .ant-badge-count {
            background-color: #448aff !important;
            border-radius: 6px !important;
            border: none;
            box-shadow: none;
        }

        .menu-button-base {
            padding: 0 7.5px !important;
        }

        .ant-table {
            tr,
            th,
            td {
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                white-space: nowrap;
                -webkit-line-clamp: 1;
                max-width: 300px;
                word-break: break-all;
            }
        }
    }
}

#assign-agent {
    .ant-modal {
        width: 1200px !important;
    }
}

#forward-agent {
    .ant-modal {
        width: 1200px !important;
    }
}

.ant-btn-reset {
    font-size: 20px !important;
    background-color: #fff4de;
    color: #ffa800;
    cursor: pointer;
    margin-left: 10px;
    padding: 0px;
}
</style>
